import CustomDate from "../../Data/Domain/CustomDate";
import Formatter from "../../Data/Domain/Formatter";

class Offset {
  constructor({
    total_co2 = null,
    emission_projected = null,
    last_month_emission = null,
    emission_avg = null,
    emission_saving = null,
    categories_emission = [],
    scopes = null,
    emission_per_year = [],
    emission_per_month = [],
    year = null,
  }) {
    this.categories_emission = categories_emission;
    this.scopes = this.get_scopes(scopes);
    this.emission_per_year = emission_per_year;
    this.emission_per_month = emission_per_month;
    this.total_co2 = total_co2;
    this.emission_projected = emission_projected;
    this.last_month_emission = last_month_emission;
    this.emission_avg = emission_avg;
    this.emission_saving = emission_saving;
    this.year = year;
  }

  static formatScopes(scope) {
    if (scope.includes("scope")) {
      return "Scope " + scope.split("scope")[1];
    }
    return scope;
  }

  get_scopes(scopes) {
    const scopes_data = {
      scope1: {
        quantity: 0,
        percent: 0,
      },
      scope2: {
        quantity: 0,
        percent: 0,
      },
      scope3: {
        quantity: 0,
        percent: 0,
      },
      total: 0,
    };
    return scopes ? scopes : scopes_data;
  }

  scopes_for_table() {
    const scopesArray = Object.keys(this.scopes).map((scopeKey) => {
      if (scopeKey === "total") {
        return {
          id: scopeKey,
          scope: scopeKey,
          emissions: Formatter.formatNumber(this.scopes[scopeKey]),
        };
      }
      return {
        id: scopeKey,
        scope: Offset.formatScopes(scopeKey),
        emissions: Formatter.formatNumber(this.scopes[scopeKey].quantity),
        percent: Formatter.formatNumber(this.scopes[scopeKey].percent),
      };
    });
    return scopesArray;
  }

  formatterYearForTable() {
    const formattedEmissionPerYearData = this.emission_per_year.map((item) => ({
      ...item,
      emission: Formatter.formatNumber(item.emission),
    }));
    return formattedEmissionPerYearData;
  }

  formattedEmissionForTable() {
    const formattedEmissionPerDateData = this.emission_per_month.map(
      (item) => ({
        ...item,
        tons: Formatter.formatNumber(item.tons),
        date: new CustomDate(item.date).getMonthName(),
      })
    );
    return formattedEmissionPerDateData;
  }
}

export default Offset;
